"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var css_1 = require("../../css");
var styles = {
    main: {
        d: 'inline-block',
        bdrad: '50%',
        animation: 'spinner-circle .3s infinite linear',
        w: '16px',
        h: '16px',
        bd: '1px solid rgba(0,0,0,.25)',
        bdl: '1px solid transparent',
        '@keyframes spinner-circle': {
            to: {
                transform: 'rotate(359.9deg)',
            },
        },
    },
};
var SpinnerCircle = css_1.useStyles(styles, function SpinnerCircle(_a, styles) {
    var _b = _a.size, size = _b === void 0 ? 0 : _b, color = _a.color;
    var style = {};
    if (color) {
        var bd = Math.min(3, Math.max(1, size));
        style.border = bd + "px solid " + color;
        style.borderLeft = bd + "px solid transparent";
    }
    if (size) {
        style.width = 16 + size * 8 + "px";
        style.height = 16 + size * 8 + "px";
    }
    return react_1.createElement('div', {
        className: styles.main,
        style: style,
    });
});
exports.default = SpinnerCircle;
//# sourceMappingURL=index.js.map